module.exports = __webpack_public_path__ + "FileAPI.flash.swf";


//////////////////
// WEBPACK FOOTER
// ./vendor/file-api/dist/FileAPI.flash.swf
// module id = 7381707662799786
// module chunks = 0